import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import PaginatorSwitcher from 'components/Paginator/PaginatorSwitcher/desktop';

import useCurrentGifts from '../../../../model/useCurrentGifts/useCurrentGifts';
import CurrentGiftsItem from './CurrentGiftsItem';
import './CurrentGifts.scss';

const b = block('current-gifts-desktop');

const CurrentGifts = () => {
  const locale = useSelector(s => s.locale.locale);
  const { values, handlers } = useCurrentGifts();

  const headers = [
    locale.name,
    locale.image,
    locale.points2,
    locale.status,
    locale.actions,
  ].map((t, i )=> (
    <div className={b('table-cell')} key={i}>{t}</div>
  ));

  const items = values.items.map(t => (
    <CurrentGiftsItem item={t} key={t.id} />
  ));

  return (
    <article className={b()}>
      <section className={b('table')}>
        <div className={b('table-header')}>{headers}</div>
        {items}
      </section>

      <div className={b('paginator-wrapper')}>
        <div className={b('extra')}>
          <div className={b('extra-info')}>
            {values.count} {locale.records}
          </div>
        </div>
        <PaginatorSwitcher
          count={values.count}
          currentPage={values.state.page}
          onPageClick={handlers.handlePageChange}
          itemsOnPage={{ value: values.activeItemsOnPage }}
        />
      </div>
    </article>
  );
};

export default CurrentGifts;
